import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';

/* Firebase bootstrap. Every value here is public — they ship in the bundle by
 * design; the gate is the SUPER_ADMIN claim and, when the live lane exists,
 * Firestore rules. */

export interface FirebaseSettings {
  apiKey: string;
  authDomain: string;
  projectId: string;
  appId?: string;
  storageBucket?: string;
  messagingSenderId?: string;
}

let app: FirebaseApp | undefined;
let auth: Auth | undefined;
let db: Firestore | undefined;

export function firebaseSettings(): FirebaseSettings | null {
  const apiKey = import.meta.env.VITE_FIREBASE_API_KEY;
  const authDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;
  if (!apiKey || !authDomain || !projectId) return null;
  return {
    apiKey,
    authDomain,
    projectId,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  };
}

/** Null when the build carries no Firebase config. The app then renders a
 *  "not configured" state rather than throwing on boot — a console that crashes
 *  before it can say why is worse than one that says why. */
export function getFirebaseAuth(): Auth | null {
  const settings = firebaseSettings();
  if (!settings) return null;
  if (!app) app = initializeApp(settings);
  if (!auth) auth = getAuth(app);
  return auth;
}

export function getDb(): Firestore | null {
  const settings = firebaseSettings();
  if (!settings) return null;
  if (!app) app = initializeApp(settings);
  if (!db) db = getFirestore(app);
  return db;
}
